import React from 'react';
import { ParagraphSmall } from '../typography';
import { ModalV2Dialog } from '../modal-v2';
import { useAcceptTOS } from '../../../modules/account/api';
import { useRootStore } from '../../context/store';
import { useAuthActions } from '../../context/auth';
import { useHistory } from 'react-router-dom';

type TOSModalProps = {
  onSuccess: VoidFunction;
};

export const TOSModal = ({ onSuccess }: TOSModalProps): JSX.Element => {
  const { mutate: acceptTOS, isLoading: isAcceptingTOS } = useAcceptTOS({
    onSuccess,
  });
  const [, rootStoreActions] = useRootStore();
  const { logout } = useAuthActions();
  const history = useHistory();

  const onRejectTOS = () => {
    rootStoreActions.wipeAll({});
    logout();
    history.push('/');
  };

  return (
    <ModalV2Dialog
      title="Terms and policies"
      secondaryButton={{ children: 'No, I do not accept', onClick: () => onRejectTOS(), isDisabled: isAcceptingTOS }}
      primaryButton={{
        children: isAcceptingTOS ? 'Accepting...' : 'Yes, I accept',
        onClick: () => acceptTOS(),
        isLoading: isAcceptingTOS,
      }}
      onClose={() => {}}
      style={{ width: '500px' }}
    >
      <ParagraphSmall>
        To use Corsmed's products and services, you have to agree to our terms and policies available on&nbsp;
        <a href="https://corsmed.com/legal" target="_blank" rel="noreferrer">
          <strong>corsmed.com/legal</strong>
        </a>
        .
      </ParagraphSmall>
    </ModalV2Dialog>
  );
};

export default TOSModal;
